import { Button, Loading } from 'components'
import { useConfirmation } from 'hooks/useConfirmation'
import { useAccountActions } from 'hooks/userHooks'
import { useCallback, useEffect } from 'react'
import { noop } from 'utils'
import getLocalized from 'i18n'
import { UserType } from 'types'
const localized = getLocalized()

export type DisableBtnProps = {
  userId: string
  userType?: UserType
  disabled?: boolean
  onDone?: (message: string) => void
  onError?: (message: string) => void
}
export const DisableBtn = ({
  disabled = false,
  userType = undefined,
  userId,
  onDone = noop,
  onError = noop,
}: DisableBtnProps) => {
  const [state, { deactivate }] = useAccountActions()

  const confirmClick = useConfirmation({
    header: localized.confirmationModal.deactivate.header,
    body: localized.confirmationModal.deactivate.body,
    confirmText: localized.confirmationModal.deactivate.confirmText,
  })

  const deactivateUser = useCallback(async () => {
    if (await confirmClick()) {
      deactivate({ userId, userType })
    }
  }, [userId, userType, deactivate, confirmClick])

  useEffect(() => {
    if (state.matches('success')) {
      onDone('User has been deactivated')
    } else if (state.matches('failed')) {
      onError('Failed deactivating user, please try again')
    }
  }, [state, onDone, onError])

  return (
    <Button
      type="button"
      variant="buttons.outline"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
      }}
      disabled={disabled || state.matches('syncing')}
      onClick={deactivateUser}>
      {state.matches('syncing') ? <Loading /> : <span>Disable account</span>}
    </Button>
  )
}
